import React, { FC, Fragment } from "react";
import { View } from "react-native";
import {
  AnswersProjection,
  AnswersProvider,
  QuestionProjection,
  QuestionType,
  QuestionItems as QuestionItemsType,
  QuestionItemProvider,
  questionIsHostScreen,
} from "@lookiero/sty-psp-quiz-style-profile-common-ui";
import { Divider } from "../../../../components/atoms/divider/Divider";
import { HostDefaultQuestionItem } from "./HostDefaultQuestionItem";
import { HostScreenQuestionItem } from "./HostScreenQuestionItem";
import { Question } from "./Question";

const NullQuestionItem: FC = () => null;

const questionItems: QuestionItemsType = {
  [QuestionType.HOST_DEFAULT]: HostDefaultQuestionItem,
  [QuestionType.HOST_SCREEN]: HostScreenQuestionItem,
  [QuestionType.HOST_SCREEN_WITH_SUMMARY]: NullQuestionItem,
  [QuestionType.IMAGE]: NullQuestionItem,
  [QuestionType.ROUNDED_BUTTON]: NullQuestionItem,
  [QuestionType.ROUNDED_BUTTON_WITH_ICON_ON_SELECTED]: NullQuestionItem,
  [QuestionType.SQUARED_BUTTON]: NullQuestionItem,
  [QuestionType.HOST_SELECT]: NullQuestionItem,
  [QuestionType.OPTION]: NullQuestionItem,
  [QuestionType.HOST_HEIGHT_METRIC]: NullQuestionItem,
  [QuestionType.HOST_WEIGHT_METRIC]: NullQuestionItem,
  [QuestionType.HOST_HEIGHT_IMPERIAL]: NullQuestionItem,
  [QuestionType.HOST_WEIGHT_IMPERIAL]: NullQuestionItem,
  [QuestionType.HOST_RANK]: NullQuestionItem,
  [QuestionType.CHECKBOX]: NullQuestionItem,
  [QuestionType.HOST_DATE]: NullQuestionItem,
  [QuestionType.HOST_IMAGE_UPLOAD]: NullQuestionItem,
  [QuestionType.SOCIAL_NETWORKS_INPUT]: NullQuestionItem,
  [QuestionType.STRIKE_OUT_AVOID_BUTTON_WITH_ICON]: NullQuestionItem,
  [QuestionType.STRIKE_OUT_AVOID_BUTTON]: NullQuestionItem,
  [QuestionType.HOST_INPUT_PILLS]: NullQuestionItem,
  [QuestionType.STRIKE_OUT_BUTTON_WITH_COLOR]: NullQuestionItem,
  [QuestionType.STRIKE_OUT_BUTTON_WITH_PRINT]: NullQuestionItem,
  [QuestionType.BUTTON_WITH_ICON]: NullQuestionItem,
  [QuestionType.FIT_BUTTON_WITH_ICON]: NullQuestionItem,
  [QuestionType.AVOID_IMAGE]: NullQuestionItem,
  [QuestionType.HOST_PRICE_SLIDER]: NullQuestionItem,
  [QuestionType.SLIDER_OPTION]: NullQuestionItem,
  [QuestionType.SKIN]: NullQuestionItem,
  [QuestionType.NUMBER_WITH_CURRENCY]: NullQuestionItem,
};

interface QuestionsProps {
  readonly questions: QuestionProjection[];
  readonly answers: AnswersProjection;
}

const Questions: FC<QuestionsProps> = ({ questions, answers }) => (
  <View testID="style-profile-questions">
    <QuestionItemProvider questionItems={questionItems}>
      <AnswersProvider answers={answers} questions={questions}>
        {questions.map((question, index) => (
          <Fragment key={question.id}>
            <Question question={question} questionParentId="" />
            {questionIsHostScreen(question) && index < questions.length - 1 && <Divider />}
          </Fragment>
        ))}
      </AnswersProvider>
    </QuestionItemProvider>
  </View>
);

export { Questions };
